import {
  Button,
  Checkbox,
  DatePicker,
  Flex,
  Form,
  Input,
  InputNumber,
  Select,
  Tabs,
} from "antd";
import React, { useState } from "react";
import LotteryNumbersTable from "./LotteryNumbersTable";
import api from "../../../../api";
import { useToast } from "../../../../components/toast/toast";
import CustomEditor from "../../../../components/reactquill/CustomEditor";
import LotteryAwardTable from "./LotteryAwardTable";
import LotteryDraw from "./LotteryDraw";
import UploadImage from "../../../../components/upload/UploadImage";
import UploadGallery from "../../../../components/upload/UploadGallery";

const LotteryTabs = ({
  lotteryId,
  form,
  onFinish,
  isLoading,
  editorData,
  setEditorData,
  trigger,
  activeKey,
  setActiveKey,
  thumbnail,
  setThumbnail,
  gallery,
  setGallery,
}) => {
  const [bankData, setBankData] = useState([]);
  const toast = useToast();

  // Form submit
  const handleFinish = (values) => {
    // values.images = fileList-ийн url-г дамжуулах жишээ:
    // const uploadedUrls = fileList
    //   .filter((file) => file.status === "done")
    //   .map((file) => file.url || (file.response && file.response.url))
    //   .filter(Boolean);

    const finalValues = {
      ...values,
      content: JSON.stringify(editorData) ?? "",
      images: {
        thumbnail,
        gallery,
      },
    };

    // console.log("Final form values:", finalValues);
    onFinish(finalValues);
  };

  const onChangeTab = async (key) => {
    // console.log("Active Tab:", key);
    setActiveKey(key);
    const res = await api.get_bank_list();
    // console.log("bankData --->", res);
    if (res.status === 200) {
      setBankData(res.data.data);
    }
  };

  const items = [
    {
      key: "1",
      label: "Дугаар",
      children: (
        <LotteryNumbersTable
          lotteryId={lotteryId}
          trigger={trigger}
          activeKey={activeKey}
        />
      ),
    },
    {
      key: "2",
      label: "Шагнал",
      children: (
        <LotteryAwardTable lotteryId={lotteryId} activeKey={activeKey} />
      ),
    },
    {
      key: "3",
      label: "Мэдээлэл",
      children: (
        <Form
          form={form}
          layout="vertical"
          style={{
            display: "flex",
            flexDirection: "column",
            // backgroundColor: "red",
          }}
          onFinish={handleFinish}
        >
          <Flex style={{ width: "100%" }}>
            <Flex
              vertical
              style={{
                padding: "0 20px 20px",
                width: "100%",
                margin: "0 auto",
              }}
            >
              {/* Зураг Upload хийх */}
              {/* --- THUMBNAIL & НЭГ ЗУРАГ --- */}
              <UploadImage
                label="Thumbnail"
                value={thumbnail}
                onUpload={setThumbnail}
              />
              {/* --- GALLERY & ОЛОН ЗУРАГ --- */}
              <UploadGallery
                label="Gallery"
                value={gallery}
                onChange={setGallery}
              />

              <Form.Item
                name="title"
                label="Гарчиг"
                rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px" }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="slug"
                label="Slug"
                rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px" }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                // name="content"
                label="Товч тайлбар"
                style={{ marginBottom: "14px" }}
                rules={[{ required: true, message: "Тайлбар шаардлагатай" }]}
              >
                {/* <TextArea rows={4} /> */}
                <CustomEditor
                  value={editorData?.content}
                  onChange={(value) => {
                    setEditorData((prev) => ({ ...prev, content: value }));
                  }}
                />
              </Form.Item>
              <Form.Item
                // name="info"
                label="Мэдээлэл"
                style={{ marginBottom: "14px" }}
              >
                <CustomEditor
                  value={editorData?.info}
                  onChange={(value) => {
                    setEditorData((prev) => ({ ...prev, info: value }));
                  }}
                />
              </Form.Item>

              <Form.Item
                // name="how_to"
                label="Хэрхэн оролцох уу"
                style={{ marginBottom: "14px" }}
              >
                <CustomEditor
                  value={editorData?.howto}
                  onChange={(value) => {
                    setEditorData((prev) => ({ ...prev, howto: value }));
                  }}
                />
              </Form.Item>

              <Form.Item
                // name="agreement"
                label="Тохирол"
                style={{ marginBottom: "14px" }}
              >
                <CustomEditor
                  value={editorData?.agreement}
                  onChange={(value) => {
                    setEditorData((prev) => ({ ...prev, agreement: value }));
                  }}
                />
              </Form.Item>
            </Flex>
            <Flex vertical style={{ width: "50%", padding: "20px" }}>
              <Form.Item
                name="ticket_prefix"
                label="Сугалааны код/дугаар"
                rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px", width: "100%" }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="ticket_price"
                label="Тасалбарын үнэ"
                rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px" }}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>

              <Form.Item
                name="ticket_qty"
                label="Сугалааны хязгаар"
                rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px" }}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
              <Form.Item
                name="ignore_triple"
                valuePropName="checked"
                style={{ marginBottom: "14px" }}
              >
                <Checkbox>3 ижил тоог алгасах</Checkbox>
              </Form.Item>
              <Form.Item
                name="ticket_limit"
                label="Нэг хэрэглэгчийн авах хязгаар"
                style={{ marginBottom: "14px" }}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
              <Form.Item
                name="sms"
                label="Мессеж утга"
                rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px", width: "100%" }}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name={"bank_number"}
                label="Дансны дугаар"
                style={{ marginBottom: "14px", width: "100%" }}
              >
                <Select
                  allowClear
                  options={bankData.map((item) => ({
                    value: item.account_number,
                    label: `${item.bank} - ${item.account_number}`,
                    disabled: !!item.lottery_id,
                  }))}
                  placeholder="-"
                />
              </Form.Item>
              <Form.Item
                name="draw_date"
                label="Тохирол явагдах өдөр"
                // rules={[{ required: true, message: "required." }]}
                style={{ marginBottom: "14px", width: "100%" }}
              >
                <DatePicker
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  style={{ width: "100%", height: "32px" }}
                />
              </Form.Item>
              <Form.Item
                name="live_link"
                label="Live линк"
                style={{ marginBottom: "14px", width: "100%" }}
              >
                <Input />
              </Form.Item>
            </Flex>
          </Flex>
          <Form.Item
            style={{
              position: "sticky",
              bottom: 0,
              background: "#fff",
              paddingTop: "10px",
              zIndex: 10,
              borderTop: "1px solid #f0f0f0",
              marginBottom: 0,
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              disabled={isLoading}
              style={{ width: "200px" }}
            >
              Хадгалах
            </Button>
          </Form.Item>
        </Form>
      ),
    },
    {
      key: "4",
      label: "Тохирол",
      children: <LotteryDraw lotteryId={lotteryId} activeKey={activeKey} />,
    },
  ];

  return (
    <Tabs
      // defaultActiveKey={activeKey || "1"}
      activeKey={activeKey || "1"}
      items={items}
      onChange={onChangeTab}
    />
  );
};

export default LotteryTabs;
